export default function(id) {
    this.id = id;
    this.show = false;
    this.birthdate = null;
    this.name = null;
    this.gender = null;

    // for step 6
    this.income = {};
    this.income.welfareAmount = null;
    this.income.salaryAmount = null;
    this.income.studentGrantAmount = null;
    this.income.alimonyAmount = null;
    this.income.childRelatedBudgetAmount = null;
    this.income.boardingWagesAmount = null;
    this.income.housingAllowanceAmount = null;
    this.income.healthAllowanceAmount = null;
    this.income.personalBudgetAmount = null;
    this.income.mortgageInterestAmount = null;
    this.income.otherAmount = null;
    this.income.pensionAmount = null;
    this.income.specifications = [];
}
